export { default } from './Ramp'
